import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from 'react-router-dom';
import { ExpectDialog, HeaderComponent, FooterComponent, LoadingDialog } from '../../shared-component';
import AppTool from '@/apps/@utils/app-tool';

const DEV_CHANGE_TYPE = {
  DISAPPEAR: 'disappear',
  APPEAR: 'appear',
}

const DEV_AVATAR = [
  {
    id: 1,
    country: 'central',
    member: [2, 3, 4]
  },
  {
    id: 2,
    country: 'central',
    member: [1, 3, 4]
  },
  {
    id: 3,
    country: 'central',
    member: [1, 2, 4]
  },
  {
    id: 4,
    country: 'central',
    member: [1, 2, 3]
  },
  {
    id: 5,
    country: 'north',
    member: [6, 7, 8, 9],
    clone: false,
    cloneId: '5-2'
  },
  {
    id: 6,
    country: 'north',
    member: [5, 7, 8, 9],
    clone: false,
    cloneId: '6-2'
  },
  {
    id: 7,
    country: 'north',
    member: [5, 6, 8, 9]
  },
  {
    id: 8,
    country: 'north',
    member: [5, 6, 7, 9]
  },
  {
    id: 9,
    country: 'north',
    member: [5, 6, 7, 8]
  },
  {
    id: 10,
    country: 'east',
    member: [11, 12, 13]
  },
  {
    id: 11,
    country: 'east',
    member: [10, 12, 13]
  },
  {
    id: 12,
    country: 'east',
    member: [10, 11, 13]
  },
  {
    id: 13,
    country: 'east',
    member: [10, 11, 12]
  },
  {
    id: 14,
    country: 'west',
    member: [15, 16, 17]
  },
  {
    id: 15,
    country: 'west',
    member: [14, 16, 17]
  },
  {
    id: 16,
    country: 'west',
    member: [14, 15, 17]
  },
  {
    id: 17,
    country: 'west',
    member: [14, 15, 16]
  },
  {
    id: 18,
    country: 'south',
    member: [19, 20, 21]
  },
  {
    id: 19,
    country: 'south',
    member: [18, 20, 21]
  },
  {
    id: 20,
    country: 'south',
    member: [18, 19, 21]
  },
  {
    id: 21,
    country: 'south',
    member: [18, 19, 20]
  },
  {
    id: 22,
    country: 'other',
    member: [23, 24, 25, 26]
  },
  {
    id: 23,
    country: 'other',
    member: [22, 24, 25, 26]
  },
  {
    id: 24,
    country: 'other',
    member: [22, 23, 25, 26]
  },
  {
    id: 25,
    country: 'other',
    member: [22, 23, 24, 26]
  },
  {
    id: 26,
    country: 'other',
    member: [22, 23, 24, 25]
  },
]

let isStartDrag = false;
let startX = 0;

const AvatarPage = () => {
  const [avatarIndex, setAvatarIndex] = useState(1);
  const [changeType, setChangeType] = useState(DEV_CHANGE_TYPE.APPEAR);
  const [avatarList, setAvatarList] = useState(DEV_AVATAR);
  const [isPhone, setIsPhone] = useState(false);
  const voiceRef = useRef(null);
  let [searchParams, setSearchParams] = useSearchParams();


  const onAvatarCnange = (type) => {
    setChangeType(DEV_CHANGE_TYPE.DISAPPEAR);
    setTimeout(() => {
      if (type === 'add') {
        if (avatarIndex === 26) {
          setAvatarIndex(1);
        } else {
          setAvatarIndex(avatarIndex + 1);
        }
      }
      else if (type === 'subtract') {
        if (avatarIndex === 1) {
          setAvatarIndex(26);
        } else {
          setAvatarIndex(avatarIndex - 1);
        }
      }
    }, 300);
  }

  const getCloenAvatarState = () => {
    let cloneId = avatarList[avatarIndex - 1]?.cloneId;
    if (cloneId !== undefined) {
      if (avatarList[avatarIndex - 1].clone) {
        return true
      }
      return false;
    }
    return false
  }

  const handleCloneAvatar = (state) => {
    let avatarListTemp = [...avatarList];
    let cloneId = avatarListTemp[avatarIndex - 1]?.cloneId;
    console.log(cloneId);
    if (cloneId !== undefined) {
      console.log(state);
      avatarListTemp[avatarIndex - 1].clone = state;
      setAvatarList(avatarListTemp);
    }
  }

  const getAvatarShowId = () => {
    let cloneId = avatarList[avatarIndex - 1]?.cloneId;
    console.log(cloneId);
    if (cloneId !== undefined && avatarList[avatarIndex - 1].clone) {
      return avatarList[avatarIndex - 1].cloneId;
    }
    return avatarIndex;
  }

  function preloadImages() {
    let images = [];
    for (let i = 1; i <= 26; i++) {
      // 预加载 body 图片
      const bodyImage = new Image();
      bodyImage.src = window.assetUrl(`/images/avatar/body/${i}.png`);
      images.push(bodyImage);

      // 预加载 bg 图片
      const bgImage = new Image();
      bgImage.src = window.assetUrl(`/images/avatar/bg/${i}.jpg`);
      images.push(bgImage);

      // 预加载 introduce 图片
      const introduceImage = new Image();
      introduceImage.src = window.assetUrl(`/images/avatar/introduce/${i}.png`);
      images.push(introduceImage);
    }

    // 将预加载的图片数组返回，如果需要可以进行其他操作
    return images;
  }

  const handlePlayVoice = (index) => {
    // 播放音频
    if (voiceRef.current) {
      voiceRef.current.pause();
    }
    voiceRef.current = new Audio(window.assetUrl(`/voice/avatar/${avatarIndex}/${index}.wav`));
    voiceRef.current.play();
  }

  const handleDragOver = (e) => {
    isStartDrag = false
  }

  const handleDragStart = (e, index) => {
    startX = e.targetTouches[0].pageX
    isStartDrag = true
    console.log('start');
  };

  const handleDrop = (e) => {
    if (!isStartDrag) {
      return
    }
    const shiftX = e.targetTouches[0].pageX - startX

    const weights = window.innerWidth * 0.15
    if (shiftX > weights) {
      onAvatarCnange('subtract')
      console.log('right');
      isStartDrag = false
    }
    else if (shiftX < -weights) {
      onAvatarCnange('add')
      console.log('left');
      isStartDrag = false
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setChangeType(DEV_CHANGE_TYPE.APPEAR);
    }, 300);
  }, [avatarIndex]);

  useEffect(() => {
    setTimeout(() => { AppTool.closeLoadingDialog('.cLoadingDialog') }, 2000);
    preloadImages()
    const index = searchParams.get('index'); // 获取 'index' 查询参数的值
    console.log(index);
    if (index) {
      setAvatarIndex(parseInt(index, 10))
    }

    setIsPhone(window.innerWidth < 1040);
    window.addEventListener('resize', () => {
      setIsPhone(window.innerWidth < 1040);
    });
  }, []);

  return (
    <div className="cAatarPage" onClick={() => { /*onAvatarCnange('add')*/ }}>
      <ExpectDialog />
      <HeaderComponent />
      <LoadingDialog />
      <img className="cMask" src={window.assetUrl(`/images/avatar/${isPhone ? 'phone' : 'pc'}-mask.png`)} />
      <div className="cAvatarCloneControl" style={{ display: avatarList[avatarIndex - 1]?.clone !== undefined ? 'flex' : 'none' }}>
        <img className="cClone1" src={window.assetUrl(`/images/avatar/sticker/${avatarIndex}-1-${getCloenAvatarState() ? 'off' : 'on'}.png`)} onClick={() => { handleCloneAvatar(false) }} />
        <img className="cClone2" src={window.assetUrl(`/images/avatar/sticker/${avatarIndex}-2-${getCloenAvatarState() ? 'on' : 'off'}.png`)} onClick={() => { handleCloneAvatar(true) }} />
      </div>
      <img
        className={`cAvatarBg ${`bg-${changeType}`}`}
        src={window.assetUrl(`/images/avatar/${isPhone ? 'phone-bg' : 'bg'}/${avatarIndex > 22 ? 22 : avatarIndex}.jpg`)}
      />
      <img className="cTitle" src={window.assetUrl(`/images/avatar/${avatarList[avatarIndex - 1].country == 'other' ? 'title-other' : 'title'}.png`)} />
      <div className='cIntroduce' >
        <img className="cText" src={window.assetUrl(`/images/avatar/${isPhone ? 'phone' : 'pc'}-introduce/${avatarIndex}.png`)} />
        <div className="cVoiceBox" style={{top : isPhone ? avatarIndex >= 22 ? "36.0vw" : "39.9vw" : "8.65vw" }}>
          <img className="cLabel" src={window.assetUrl(`/images/avatar/voice/label.png`)} />
          <div className="cVoice1 cVoice" onClick={()=>{handlePlayVoice(1)}} style={{display : avatarIndex >= 22 ? 'none' : 'block'}}>
            <img className="cOn" src={window.assetUrl(`/images/avatar/voice/voice1-1.png`)} />
            <img className="cOff" src={window.assetUrl(`/images/avatar/voice/voice1-2.png`)} />
          </div>
          <div className="cVoice2 cVoice" onClick={()=>{handlePlayVoice(2)}} style={{display : avatarIndex >= 22 ? 'none' : 'block'}}>
            <img className="cOn" src={window.assetUrl(`/images/avatar/voice/voice2-1.png`)} />
            <img className="cOff" src={window.assetUrl(`/images/avatar/voice/voice2-2.png`)} />
          </div>
          <div className="cVoice3 cVoice" onClick={()=>{handlePlayVoice(3)}} style={{display : avatarIndex >= 22 ? 'none' : 'block'}}>
            <img className="cOn" src={window.assetUrl(`/images/avatar/voice/voice3-1.png`)} />
            <img className="cOff" src={window.assetUrl(`/images/avatar/voice/voice3-2.png`)} />
          </div>
          <div className="cVoice4 cVoice" onClick={()=>{handlePlayVoice(1)}} style={{display : avatarIndex >= 22 ? 'block' : 'none'}}>
            <img className="cOn" src={window.assetUrl(`/images/avatar/voice/voice4-1.png`)} />
            <img className="cOff" src={window.assetUrl(`/images/avatar/voice/voice4-2.png`)} />
          </div>
        </div>
        <div className="cMember">
          {avatarList[avatarIndex - 1].member && avatarList[avatarIndex - 1].member.map((member, index) => {
            return <img key={index} className="cMemberImg" src={window.assetUrl(`/images/avatar/sticker/${member}.png`)} onClick={() => { setAvatarIndex(member) }} />
          })}
        </div>
      </div>
      <img className="cSwitchLeft cScaleAnimation" src={window.assetUrl(`/images/avatar/switch-left-${isPhone ? 'phone' : 'pc'}.png`)} onClick={() => { onAvatarCnange('subtract') }} />
      <img className="cSwitchRight cScaleAnimation" src={window.assetUrl(`/images/avatar/switch-right-${isPhone ? 'phone' : 'pc'}.png`)} onClick={() => { onAvatarCnange('add') }} />

      <img className={`cAvatarBody ${`avatar-${changeType}`}`} src={window.assetUrl(`/images/avatar/body/${getAvatarShowId()}.png`)}
        onTouchStart={(e) => { handleDragStart(e) }}
        onTouchMove={handleDrop}
        onTouchEnd={handleDragOver} />
      <img className={`cAvatarSpeak ${`bg-${changeType}`}`} src={window.assetUrl(`/images/avatar/phone-speak/${getAvatarShowId()}.png`)} />
      <div className='cCountryBox'>
        <img className="cCountry" style={{ opacity: avatarList[avatarIndex - 1].country == 'central' ? 1 : 0.5 }} src={window.assetUrl('/images/character/logo-central.png')} onClick={() => { setAvatarIndex(1) }} />
        <img className="cCountry" style={{ opacity: avatarList[avatarIndex - 1].country == 'north' ? 1 : 0.5 }} src={window.assetUrl('/images/character/logo-north.png')} onClick={() => { setAvatarIndex(5) }} />
        <img className="cCountry" style={{ opacity: avatarList[avatarIndex - 1].country == 'east' ? 1 : 0.5 }} src={window.assetUrl('/images/character/logo-east.png')} onClick={() => { setAvatarIndex(10) }} />
        <img className="cCountry" style={{ opacity: avatarList[avatarIndex - 1].country == 'west' ? 1 : 0.5 }} src={window.assetUrl('/images/character/logo-west.png')} onClick={() => { setAvatarIndex(14) }} />
        <img className="cCountry" style={{ opacity: avatarList[avatarIndex - 1].country == 'south' ? 1 : 0.5 }} src={window.assetUrl('/images/character/logo-south.png')} onClick={() => { setAvatarIndex(18) }} />
        <img className="cCountry" style={{ opacity: avatarList[avatarIndex - 1].country == 'other' ? 1 : 0.5 }} src={window.assetUrl('/images/character/logo-other.png')} onClick={() => { setAvatarIndex(22) }} />
      </div>
      <div className="cFooterBox">
        <FooterComponent />
      </div>

    </div>
  );
}

export default AvatarPage;